module.exports = __webpack_public_path__ + "img/edge.003dec14.png";